module.exports = __webpack_public_path__ + "static/media/after-intervention.0814f70d.md";